export default __webpack_public_path__ + "static/media/sidebar-bg.0a9b82f9.png";